import React, {useState} from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import UiSearch from "../../../_uiComponents/common/form/UiSearch";
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import profile from "../../../../styles/images/png/profile-pic.png";
import UiDateRangePicker from "../../_uiComponents/UiDateRangePicker";
import UiTableHead from "../../_uiComponents/UiTableHead";
import UiTableBody from "../../../_uiComponents/common/table/UiTableBody";
import UiTableWrapper from "../../../_uiComponents/common/table/UiTableWrapper";
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) {
              return order;
         }
         return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
         return -1;
    }
    if (b[orderBy] > a[orderBy]) {
         return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === "desc"
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
}


export default function UsersTableManage(props) {
     const [page, setPage] = React.useState(1);
     const [rowsPerPage, setRowsPerPage] = React.useState(5);
     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [show, setShow] = useState(false);


     const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
   
     const { rowValueList, totalRecords  } = useSelector((state) => {
          return {
               rowValueList: state.lookupTable.tableValueList.data,
               totalRecords: state.lookupTable.tableValueList.totalRecords,
          };
     });

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage + 1);
     };

     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(event.target.value);
          setPage(1);
     };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;
      
        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tabpanel-${index}`}
            {...other}
          >
            {value === index && (
              <Box sx={{ p: 3 }}>
                {children}
              </Box>
            )}
          </div>
        );
      }

    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const headings = [
        { id: "name", name: "Log" },
        { id: "date", name: "Date" },
   ];

   const data = [
        {
             id: 1,
             name: "Sales type",
             date: "07/05/2024",
             items: [
                  {
                       id: 1,
                       date: "2020-01-05",
                  },
                  {
                       id: 2,
                       date: "2020-01-02",
                  },
             ],
        },
        {
             id: 2,
             name: "Sales type",
             date: "07/05/2024",
             items: [
                  {
                       id: 1,
                       date: "2020-01-05",
                       customerId: "11091700",
                  },
                  {
                       id: 2,
                       date: "2020-01-02",
                       customerId: "Anonymous",
                  },
             ],
        },
        {
             id: 3,
             name: "Sales type",
             date: "07/05/2024",
             items: [
                  {
                       id: 1,
                       date: "2020-01-05",
                       customerId: "11091700",
                  },
                  {
                       id: 2,
                       date: "2020-01-02",
                       customerId: "Anonymous",
                  },
             ],
        },
   ];

   //Sorting
   const handleRequestSort = (event, property) => {
    console.log(property)
    const isAsc = orderBy === property && order === "asc";
    console.log(isAsc)
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
};

   //Data sorting
   const visibleRows = React.useMemo(
    () =>
         stableSort(data, getComparator(order, orderBy)).slice(
              page * rowsPerPage,
              page * rowsPerPage + rowsPerPage,
         ),
    [order, orderBy, page, rowsPerPage, data],
);

     return (
        <div>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                value={value}
                onChange={handleChange}          
                >
                    <Tab value="1" label="User Info"/>
                    <Tab value="2" label="User Log" />
                </Tabs>
            </Box>

            {/* Tab One */}
            <TabPanel value={value} index="1">
                <div className="sba-user-tabs">
                <div className="sba-user-first-tab-button">
                        <Button
                            variant="outlined"
                        >
                            Send Set Password Mail
                        </Button>
                        <Button
                            variant="contained"
                            sx={{ ml: 2 }}
                        >
                            Lock User
                        </Button>
                </div>
                    
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={3} >
                        <div className="sba-user-first-tab-image">
                            <img src={profile} />
                        </div>
                    </Grid>
                    <Grid item xs={12} lg={9} className="sba-um-second-content">
                        <Grid item xs={12} lg={8} >                           
                            <div className="sba-um-label">
                                <span>Dealer </span> 
                                <span className="sba-um-label__second">: &nbsp;Renult</span>
                            </div>
                            <div className="sba-um-label">
                                <span>Email </span>
                                <span className="sba-um-label__second">: &nbsp;nimal@gmail.com</span>
                            </div>
                            <div className="sba-um-label">
                                <span>First Name </span>
                                <span className="sba-um-label__second">:&nbsp; Nimal</span>
                            </div>
                            <div className="sba-um-label">
                                <span>Middle Name </span>
                                <span className="sba-um-label__second">: &nbsp;Nimal1</span>
                            </div>
                            <div className="sba-um-label">
                                <span>Last Name </span>
                                <span className="sba-um-label__second">: &nbsp;Nimal2</span>
                            </div>
                            <div className="sba-um-label sba-um-mobile">
                                <span>Mobile Number</span>
                                <span className={showPassword ? 'sba-um-label__second sba-um-label-show' : 'sba-um-label-hide'}>: &nbsp;071 123 4567
                                    <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    >
                                    {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </span>
                            </div>
                        </Grid>
                            
                        <Grid item xs={12} lg={4} >
                            <div className="sba-um-second-label">
                                <span className="sba-um-second-label__first">User Type</span>
                                <span className="sba-um-second-label__second">: &nbsp;Sales</span>
                            </div>
                            <div className="sba-um-second-label">
                                <p className="sba-um-second-label__first">Role </p>
                                <span className="sba-um-second-label__second">: &nbsp;Sales 1</span>
                            </div>
                            <div className="sba-um-second-label">
                                <p className="sba-um-second-label__first">Permission </p>
                                        <div className="sba-users-dropdown-manage">
                                            <SimpleTreeView >
                                                <TreeItem itemId="grid" label="Incentive">
                                                    <TreeItem itemId="grid-community" label="Create Incentive" />
                                                    <TreeItem itemId="grid-pro" label="Edit Incentive" />
                                                    <TreeItem itemId="grid-premium" label="Delete Incentive" />
                                                </TreeItem>
                                                <TreeItem itemId="grid1" label="Incentive">
                                                    <TreeItem itemId="grid-community1" label="Create Incentive" />
                                                    <TreeItem itemId="grid-pro1" label="Edit Incentive" />
                                                    <TreeItem itemId="grid-premium1" label="Delete Incentive" />
                                                </TreeItem>
                                            </SimpleTreeView>
                                        </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                </div>
            </TabPanel>
            
            {/* Tab Two */}
            <TabPanel value={value} index="2">
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={6} >
                        <UiDateRangePicker name="eee" />
                    </Grid>
                    <Grid item xs={12} lg={6} >
                        <div className="sba-um-search">
                            <UiSearch onChange={props.getTableRowValueList} />
                        </div>
                    </Grid>                    
                </Grid>

                <div className="sba-sub-table">
                <UiTableWrapper>
                         <UiTableHead
                              headings={headings}
                              order={order}
                              orderBy={orderBy}
                              onRequestSort={handleRequestSort}
                         />
                         <UiTableBody>
                              {visibleRows.map((row, index) => (
                                   <>
                                        <TableRow
                                             key={row.id}
                                             sx={{
                                                  "&:last-child td, &:last-child th":
                                                       { border: "none" },
                                             }}
                                        >
                                             <TableCell align="left">
                                                  {row.name}
                                             </TableCell>
                                             <TableCell align="center">
                                                  {row.date}
                                             </TableCell>
                                             </TableRow>
                                             </>
                                            ))}
                                             </UiTableBody>
                                             </UiTableWrapper>
               </div>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TabPanel>
          </div>
     );
}
